import React from 'react'
import moment from 'moment'

import UpcomingClassLanguage from '../../../../../pages/common/Statistic/UpcomingClassLanguage'
import Icon from '../../../../UI/Icon'
import { Avatar } from '../../../../UI'

import { arrayFromNumber, getUserName } from '../../../../../helpers'

import { imagePrefix } from '../../../../../constants'

const TutorUpcomingClass = ({ upcomingClass }) => {
  const classBanner = upcomingClass.availability_calendar.class_banner
  const studentName = getUserName(
    upcomingClass.student_user,
    upcomingClass.student_profile?.display_name,
    upcomingClass.student_profile?.display_last_name
  )
  const hour = parseFloat(upcomingClass.availability_calendar.slot)

  // TODO
  const checksContent = arrayFromNumber(3).map((check) => {
    return <Icon key={check} name="sun-check" className="w-[32px] h-[32px]" />
  })

  const languagesContent = (classBanner?.creator_profile?.languages || []).map((language) => {
    return <UpcomingClassLanguage key={language} language={language} />
  })

  return (
    <div className="w-full bg-[#FEEBDD] rounded-[4px] flex items-center my-[10px] p-[10px] shadow-upcoming-class">
      <div className="w-[290px] h-[218px]">
        <Avatar
          src={upcomingClass.student_user.profile_picture || ''}
          alt={studentName}
          className="w-full h-full !rounded-[6px]"
          defaultClassName="p-8 !object-contain"
        />
      </div>

      <div className="min-h-[218px] bg-[#fff5ee] border-[#ffca84] border-[1px] rounded-[6px] ml-[10px] flex-1 p-[20px] flex flex-col items-start">
        <div className="w-full border-b-[#f674432b] border-b-[1px] flex items-center pb-[10px]">
          <span className="text-2xl font-bold text-primary-100">
            {classBanner.class_banner_category.name}
          </span>
        </div>

        <div className="flex items-start justify-between w-full mt-[10px]">
          <div className="flex flex-col items-start flex-1 gap-y-[10px] mr-[16px]">
            <div className="flex items-center">
              <span className="w-[100px] text-xs font-medium text-[#F79009] font-Inter">
                Student
              </span>

              <h4 className="text-sm font-semibold text-primary-100 ml-[24px]">{studentName}</h4>

              <div className="ml-[8px] flex items-center gap-x-[2px]">{checksContent}</div>
            </div>

            <div className="flex items-center">
              <span className="w-[100px] text-xs font-medium text-[#F79009]">Date & Time</span>

              <h4 className="text-sm font-normal text-primary-100 ml-[24px]">
                {moment(upcomingClass.availability_calendar.day).format('MMMM DD, YYYY')}{' '}
                {hour < 10 && hour > -1 ? `0${hour}` : hour}:00
              </h4>
            </div>

            <div className="flex items-center">
              <span className="w-[100px] text-xs font-medium text-[#F79009]">Classes Before</span>

              <h4 className="text-sm font-normal text-primary-100 ml-[24px]">
                {upcomingClass.class_before_count || 0}
              </h4>
            </div>
          </div>

          <div className="flex flex-col items-start">
            <button className="mb-[10px] shadow-upcoming-class-button w-[200px] h-[32px] bg-primary-button hover:bg-primary-button-hover transition-colors duration-200 ease rounded-[8px] flex items-center justify-center text-sm font-semibold font-Inter text-white">
              Message
            </button>

            {/*<button*/}
            {/*  className="shadow-upcoming-class-button w-[200px] h-[32px] bg-white rounded-[8px] border-[#F79009] border-[1px] flex items-center justify-center text-sm font-semibold font-Inter text-[#F79009]">*/}
            {/*  Join Class*/}
            {/*</button>*/}
          </div>
        </div>

        <div className="w-full flex items-center justify-between pt-[12px] mt-auto">
          <div className="flex items-center w-[70%]">
            <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

            <ul className="flex items-center gap-x-[4px] w-[80%] flex-wrap">{languagesContent}</ul>
          </div>

          <div className="flex items-center">
            <div className="flex items-center mr-[24px]">
              <img src={'/assets/icon/globleIcon.png'} />
              <img src={`/assets/icon/britain.png`} className="w-[24px] h-[24px] ml-[4px]" />
            </div>

            <div className="flex items-center">
              <img src={`/assets/icon/homeOrangeIcon.png`} />
              <img src={`/assets/icon/poland.png`} className="w-[24px] h-[24px] ml-[4px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TutorUpcomingClass
